var o = {};
var current_scroll = 0;

jQuery(document).ready(
  
  function(){
    jQuery('.quick-view-overlay').find('span').click(
      function(){

        var $me = jQuery(this).closest('.grid__item');
        var product_handle = jQuery(this).attr('data-product-handle');

        if(jQuery('.quick-view-on').size()>0){
          closeQuickView( jQuery('.quick-view-on'), function(){ quickViewProduct($me, product_handle) });
        }else{
          quickViewProduct($me, product_handle);
        }


        return false;



      }
    );
  }
  
);


  


  function quickViewProduct($me, product_handle){
  	
    
    var $quick_view = $me.find('.product-quick-view-container');
    
    
    if($me.hasClass('quick-view-on')){ // Close quickview
      
      closeQuickView($me);
      
    }else{ // Open quickview
      
      if(location.href.indexOf('/collections/') > -1){ // Are we in a collection? 
 	      var w = $(window).width()-326;
    	  $quick_view.css('width', w+'px');
	      $quick_view.css('right', '-30px');
      }
      
      $me.addClass('quick-view-on');
      $me.find('.product-quick-view-container').show().css('height', 'auto!important;');
      $quick_view.find('a[href=#close]').click(function(){
        
        closeQuickView($me);
        
     });
      
      
      $template = jQuery('#quick-view-template').clone();
      
      
      
      jQuery.getJSON('/products/'+product_handle+'.js', function(product) {
        
		o = (product);
        

        var img = product.featured_image.replace('.jpg', '_large.jpg').replace('.png', '_large.png');
        
        $template.find('.photos').find('img').attr('src', img);
        
        // Variables
        
        price = product.price;
        price = '$'+price.toFixed(2);
        
        $template.html($template.html().replace('{title}', product.title));
        $template.html($template.html().replace('{price}', price));
        $template.html($template.html().replace('{description}', product.description));
        
        
        var $options = $('<ul>');
        var $variants = $('<select>');
        
        $variants.attr('name', 'id');
        
        for(var i in o.options){
          var $li = $('<li>');
          var p = o.options[i]; console.log(p.values);
         
          for(var j in o.options[i].values){
            var $span = $('<span>');
            $span.text(o.options[i].values[j])
//           	$li.append($span);
          }
          
          $options.append($li);
          
        }
        
        // VARIANTS
        for(var i in o.variants){
          var $option = $('<option>');
          $option.val(o.variants[i].id);
          $option.text(o.variants[i].title);
          $variants.append($option);
        }
        
        $options.append($('<li>').append($variants));
        
        $template.html($template.html().replace('{options}', $options.html()));
        
        
        
        $template.find('form').submit(function(){

          ShopifyAPI.addItemFromForm(
          $(this),
          function(r){ console.log(r); ajaxCart.itemAddedCallback() },
          function(r){ console.log(r); alert('error');}
       	);
        return false;
      })

        
        $me.find('.product-quick-view-container').append($template.fadeIn());
        
      } );
      
      current_scroll = $(window).scrollTop();
      
      $me.animate({marginBottom:500},
		function(){
        	var st = $me.find('.product-quick-view-container').offset().top-60;
        	$('html, body').animate({ scrollTop: st }, 1000);
     		}
		);
    }
    
    
    
  }
  
  
  function closeQuickView($me, callback){
  	
    $me.removeClass('quick-view-on');
    
    if(callback == null) $('html, body').animate({ scrollTop: current_scroll }, 1000);
    $me.animate({marginBottom:0}, function(){
	    $me.find('.product-quick-view-container').hide();
    	$me.find('#quick-view-template').remove();
    });
    
    $me.find('.product-quick-view-container').animate(
      {height:0},
      function(){
      	if(callback != null) callback();
      }
   	);
    
    
  }
